import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const navItems = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Pricing", to: "/pricing" },
  { label: "Blog", to: "/blog" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/70 border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" data-testid="header-logo-link" className="flex items-center gap-2">
            <span className="w-8 h-8 bg-[#FF5A00] flex items-center justify-center font-heading font-extrabold text-white text-lg">C</span>
            <span className="font-heading font-extrabold tracking-tight text-lg leading-none">
              CORE SURE<span className="block text-[10px] font-bold tracking-widest text-muted-foreground uppercase">Business Services</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`nav-link-${item.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) =>
                  `text-sm font-medium transition-colors hover:text-[#FF5A00] ${
                    isActive ? "text-[#FF5A00]" : "text-foreground"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/appointment"
              data-testid="nav-appointment-btn"
              className="inline-flex items-center gap-1 bg-[#FF5A00] hover:bg-[#E04F00] text-white text-sm font-bold px-5 py-2.5 transition-colors"
            >
              Book Appointment <ArrowUpRight size={16} />
            </Link>
          </nav>

          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <nav data-testid="mobile-nav-menu" className="md:hidden bg-white border-t border-border px-4 py-4 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => setOpen(false)}
              className="block py-2.5 text-sm font-medium hover:text-[#FF5A00]"
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/appointment"
            onClick={() => setOpen(false)}
            className="block bg-[#FF5A00] text-white text-center font-bold py-3 mt-2"
          >
            Book Appointment
          </Link>
        </nav>
      )}
    </header>
  );
};
